import { URLConstructor } from './URLBuilder'

export const getQueryParamsAsObject = (): Record<string, string> => {
    const queryString: string = window.location.search
    const urlParams: URLSearchParams = new URLSearchParams(queryString)
    const params: Record<string, string> = {}

    urlParams.forEach((value: string, key: string): void => {
        params[key] = value
    })

    return params
}

/**
 * Does query param exist?
 *
 * @param param - The query param to check for.
 * @returns - True if the query param exists.
 */
export const hasQueryParam = (param: string): boolean => {
    const urlParams: URLSearchParams = new URLSearchParams(window.location.search)

    return urlParams.has(param)
}

/**
 * Get value of query param.
 *
 * @param param - The query param to check for.
 * @returns - The value of the query param.
 */
export const getQueryParam = (param: string): Nullable<string> => {
    const urlParams: URLSearchParams = new URLSearchParams(window.location.search)

    return urlParams.get(param)
}

/**
 * Redirect to a given URL.
 *
 * @param url - The URL to redirect to.
 */
export const redirectToURL = (url: URLConstructor): void => {
    window.location.href = url.constructURL()
}
